import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    OnDestroy,
} from "@angular/core";
import { IonModal } from "@ionic/angular";
import moment from "moment";
import { Subject } from "rxjs";

@Component({
    selector: "app-date-time-picker",
    templateUrl: "./date-time-picker.component.html",
    styleUrls: ["./date-time-picker.component.css"],
    standalone: false,
})
export class DateTimePickerComponent implements OnInit, OnDestroy {
    @ViewChild("datepicker", { static: true }) modal: IonModal;

    @Input() name = "";
    @Input() label = "Date";
    @Input() format = "DD MMM YYYY";
    @Input() value = moment().format(this.format);
    @Input() minDate = "";
    @Input() maxDate = "";
    @Input() removeStyling: boolean = false;
    @Output() onChange = new EventEmitter<string>();

    public rawValue: string = "";

    private readonly unsubscribe$ = new Subject<void>();
    constructor() {}

    ngOnInit(): void {
        this.rawValue = this.value;
        this.value = moment(this.value).format(this.format);
        this.label = this.label || "Date";
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    public setValue(event) {
        this.value = moment(event.detail.value).format(this.format);
        this.modal.dismiss();
        this.onChange.emit(event.detail.value);
    }
}
